import {t} from '@lingui/macro'
import {Form, Formik} from 'formik'
import React, {ChangeEvent} from 'react'

import {Button, Stack, FormikInput as Input} from '@pleo-io/telescope'

import {FormValues, validationSchema} from './form.validate'

export function EmailInput({
    initialValue,
    isLoading,
    onSubmit,
}: {
    initialValue: string | null
    isLoading?: boolean
    onSubmit: (value: string) => void
}) {
    return (
        <Formik<FormValues>
            initialValues={{email: initialValue ?? ''}}
            validationSchema={validationSchema}
            validateOnMount
            enableReinitialize
            onSubmit={({email}) => {
                onSubmit(email)
            }}
        >
            {({isValid, isSubmitting, setFieldValue}) => (
                <Form>
                    <Stack space={40} stretch>
                        <Input
                            label={t`Work email`}
                            autoFocus
                            autoComplete="on"
                            name="email"
                            onChange={(event: ChangeEvent<HTMLInputElement>) =>
                                setFieldValue('email', event.target.value.trim())
                            }
                            placeholder={t`ie. name@email.com`}
                            variant="naked"
                        />
                        <Button
                            loading={isSubmitting || isLoading}
                            type="submit"
                            variant="primary"
                            disabled={!isValid || isSubmitting}
                        >
                            {t`Continue`}
                        </Button>
                    </Stack>
                </Form>
            )}
        </Formik>
    )
}
